export default __webpack_public_path__ + "static/media/my_location.bc4ca4a3.svg";